<template>
    <div class="collapse navbar-collapse d-flex justify-content-between" id="navbarSupportedContent">
        <div>
            <!-- Left Of Navbar -->
            <div class="navbar-brand">
                <img src="/img/askmygp-logo-white.png">
            </div>

            <span v-text='$root.user ? $root.user.provider.name : ""'></span> <span v-text='isServiceAvailable() ? "" : "(Offline)"'></span>


        </div>
        <!-- Right Side Of Navbar -->
        <ul class="navbar-nav ml-auto">
            <!-- Authentication Links -->

            <li v-if='$root.user && $root.user.id' class="nav-item dropdown">
                <a id="navbarDropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-pre>
                    <navname></navname> <span class="caret"></span>
                </a>

                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="/logout">
                        {{ $t('translations.logout')}}
                    </a>
                </div>
            </li>
            <!-- <li v-else><a class="nav-link" href="{{ route('login') }}"></a></li> -->

        </ul>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
        };
    },
    methods: {
    }
}
</script>
